// extracted by mini-css-extract-plugin
export var linkWrapper = "AnchorMenu-module--linkWrapper--bc9e6";
export var mobileMenu = "AnchorMenu-module--mobileMenu--ad846";
export var link = "AnchorMenu-module--link--e0765";
export var current = "AnchorMenu-module--current--a9b56";